// src/styles/GlobalStyles.ts
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  body,
  html {
    font-family: 'Inter', system-ui, sans-serif;
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
    color: #3f4c5a;
    background-color: #d6e0ea;
    background-image: radial-gradient(1000px 700px at 20% 0%, #f8fbff 0%, #e6eef7 55%, #8da5bf  100%);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    font-weight: 400;
    width: 100% !important;
    height: 100% !important;
    overflow-x: hidden;
  }
  h1, h2, h3, h4, h5 {
    font-family: 'Satoshi', 'Inter', system-ui, sans-serif;
    font-weight: 700;
    color: #1f2b3a;
    margin: 0;
    padding: 0;
  }
  h1 {
    font-size: clamp(40px, 6vw, 80px);
    line-height: 1.1;
    letter-spacing: -0.022em;
  }
  h2 {
    font-size: clamp(28px, 3.6vw, 48px);
    font-weight: 500;
    line-height: 1.1;
    letter-spacing: -0.02em;
  }
  h3 {
    font-size: clamp(20px, 2.2vw, 24px);
    line-height: 1.15;
    letter-spacing: -0.033em;
  }
  button, input, textarea, select {
    font-family: inherit;
  }
  p {
    font-size: 16px;
    color: #4a5a6b;
  }
  a {
    color: #1f2b3a;
    font-weight: 400;
    text-decoration: none;
  }
  a:hover,
  a:focus {
    color: #0b1422;
    text-decoration: none;
  }
`;

export default GlobalStyles;
